import { createContext } from 'react'

import type { IZaiChatObserverContextData } from './types'

export const ZaiChatObserverContext = createContext<IZaiChatObserverContextData | null>(null)
